export default __webpack_public_path__ + "static/media/icon_story_1.f61a5749.svg";